import {useT} from 'react-polyglot-hooks';
import {allHtmlLinksNewWindow} from './allHtmlLinksNewWindow';

export const getCopy = (key: string) => {
    const t = useT();
    const cms = t(key).toString();
    return cms ? allHtmlLinksNewWindow(cms) : '';
}